import { render, staticRenderFns } from "./AccountInsuranceRefundDetail.vue?vue&type=template&id=019a0380&"
import script from "./AccountInsuranceRefundDetail.vue?vue&type=script&lang=js&"
export * from "./AccountInsuranceRefundDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports